import { z } from 'zod';
import { annotationSchema } from './annotationSchema';
import { targetSchema } from './targetSchema';

export const drugSchema = z.object({
  /** identifier of the chemical */
  id: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  /** list of synonyms  */
  synonyms: z.array(z.string()),
  brandNames: z.array(z.string()),
  /** does drug cross blood brain barrier */
  bloodBrainBarrier: z.string(),
  /** list of annotations */
  references: z.array(annotationSchema),
  /** list of targets */
  targets: z.array(targetSchema),
});
